import Api from './api';

const PATH = '/llm-key-word';

const getAllLLMKewWord = async (llmId) => {
    try {
      const response = await Api.get(`${PATH}/get-all/${llmId}`);
      return response.data;
    } catch (err) {
      throw err;
    }
}

const getAllLLMKewWordEventSystem = async (llmId) => {
    try {
      const response = await Api.get(`${PATH}/get-all-event-system/${llmId}`);
      return response.data;
    } catch (err) {
      throw err;
    }
}

const getAllLLMKewWordByLlmAndLlmEvent = async (llmId, llmEventId) => {
    try {
      const response = await Api.get(`${PATH}/get-all-by-llm-and-event/${llmId}/${llmEventId}`);
      return response.data;
    } catch (err) {
      throw err;
    }
}

const create = async (input) => { 
  try {
    const response = await Api.post(PATH, input);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const updateByLLMAndEvent = async (input) => { 
  try {
    const response = await Api.put(PATH, input);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const deleteById = async (id) => {
  try {
    const response = await Api.delete(`${PATH}/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

export {
  getAllLLMKewWord,
  create, 
  deleteById,
  getAllLLMKewWordByLlmAndLlmEvent,
  updateByLLMAndEvent,
  getAllLLMKewWordEventSystem
};